export default __webpack_public_path__ + "static/media/feature-2.c600be32.svg";